/*
 * @Author: lijinyang
 * @FilePath: /mall-fe/src/comps/h5/Search/components/ProductList.tsx
 * @Description: 商品列表组件
 *
 */
import React from 'react';
// React.useLayoutEffect = React.useEffect;
import { materialsSearch } from 'api/mall';
import CardSkeleton from 'comps/CardSkeleton';
import ListSkeleton from 'comps/ListSkeleton';
import MaterialsCondition from './MallCondition';

import VirtualList from 'comps/VirtualList';
import Button from 'comps/Button';
import Nodata from 'comps/Nodata';
import { ResizeSensor } from 'css-element-queries';
import { LocContext, UserContext } from 'libs/contexts';
import { useRouter } from 'next/router';
import { splitEvery } from 'rambdax';
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import ProductListItem from './ProductListItem';
import MaterialsCard from './MaterialsCard';
import { SEARCH_TYPE } from '../constants/mall-condition';
import { useNetActionPriceContext } from 'libs/contexts';
import { UserSource } from 'libs/enums';

const defPageSize = 10;
type ConditionItem = {
  name: any;
  type?: any;
  values: {
    name: any;
    sysNo: any;
    active?: boolean;
    primary?: boolean;
    kdyxTypeList?: number[];
  }[];
};
type IProductList = {
  shopSysNo?: string;
  toolHeight?: number;
  showCondition?: boolean;
  pCondition?: {
    key: string;
    shopInnerTab?: number;
  };
};

const LIST_TYPE = {
  card: {
    name: 'card',
    height: 332,
  },
  list: {
    name: 'list',
    height: 162,
  },
  noShopCardHeight: 316,
};

export default function ProductListComp({
  shopSysNo,
  toolHeight = 0,
  showCondition = true,
  pCondition,
}: IProductList) {
  const router = useRouter();
  const agreementSysNoList = router.query.agreementSysNo ? [router.query.agreementSysNo] : [];
  const contractAgreementSysNoList = router.query.contractSysNo ? [router.query.contractSysNo] : [];
  const { location } = useContext(LocContext);
  const [data, setData] = useState<any>([]);
  const hasScroll = useRef(true);
  const [loadingText, setLoadingText] = useState('正在加载中');
  const [condition, setCondition] = useState<{ [key: string]: any }>({
    sorts: [],
    keywordType: SEARCH_TYPE.DEFAULT, // 搜索类型 0 默认 1 按交易规则 2 按合同
    key: router.query.key,
    shopInnerTab: pCondition?.shopInnerTab ?? null,
    catId: router.query.catId ?? null,
    shopSysNo: shopSysNo || router.query.shopSysNo,
    agreementSysNoList,
    contractAgreementSysNoList,
  });

  const [listHeight, setListHeight] = useState(600);
  const params = useRef<any>({
    pageNo: 1,
    levelCode: '',
    sorts: [],
    keywordType: SEARCH_TYPE.DEFAULT, // 搜索类型 0 默认 1 按交易规则 2 按合同
    pageSize: defPageSize,
    catId: router.query.catId ?? null,
    shopSysNo: shopSysNo || router.query.shopSysNo,
    shopInnerTab: pCondition?.shopInnerTab ?? null,
    key: router.query.key ?? '',
    agreementSysNoList,
    contractAgreementSysNoList,
  });

  const loading = useRef(false);
  const listRef = useRef<HTMLElement>();
  const totalPage = useRef(1);
  const [conditionList, setConditionList] = useState<any>();
  const [conditionTypeList, setConditionTypeList] = useState<{
    categoryList: any[];
    hotCategoryList: any[];
  }>();
  const conditionListRef = useRef<any>();
  const [showChangeArea, setShowChangeArea] = useState(false);
  const conditionRef = useRef({ areaPicker: {}, checkCondition: () => {} });
  const getNetPriceList = useNetActionPriceContext();
  const [cardHeight, setCardHeight] = useState(293); // 293 | 140
  const [listType, setListType] = useState(LIST_TYPE.card.name);
  const [endSkeleton, setEndSkeleton] = useState(false);
  const resData = useRef<any>();
  const conditionHeight = showCondition ? 63 : 0;
  const userInfo = useContext(UserContext); // 获取上下文用户信息
  const isOutSide = userInfo?.organizationSource === UserSource.outside; //是否为外部采购商

  // 获取商品列表
  const getList = async (init?: boolean, initDatas?: any[]) => {
    setShowChangeArea(
      [
        params.current?.attributeNameList,
        params.current?.attributeValueList,
        params.current?.brandSysNoList,
      ].every((v) => !v || v.length === 0),
    );
    delete params.current.categorySysNoList;
    const res: any = initDatas ? initDatas : await materialsSearch(params.current);
    const spuList = res?.data?.spuList;
    const brandList = res?.data?.brandList || [];
    const spuAttributeList = res?.data?.spuAttributeList || [];
    let categoryList = res?.data?.categoryList || [];
    let hotCategoryList = res?.data?.hotCategoryList || [];
    const upstreamSupplierList = res?.data?.upstreamSupplierList || [];
    // save load data
    const brands = { name: '品牌', values: brandList };
    let upstreams;
    upstreams = {
      name: '配送商',
      values: upstreamSupplierList.map((i) => ({
        name: i.supplierName,
        sysNo: i.sysNo,
        parentName: '配送商',
      })),
    };

    const chunkArr = spuList?.datas ? splitEvery(2, spuList?.datas) : [];
    loading.current = false;
    totalPage.current = spuList?.totalPage ?? 0;
    const arr = init ? chunkArr : [...data, ...chunkArr];
    setData(arr);
    getNetPriceList &&
      getNetPriceList(spuList?.datas, (list) => {
        const chunkArr = splitEvery(2, list);
        const arr = init ? chunkArr : [...data, ...chunkArr];
        setData(arr);
      });
    resData.current = res;
    if (resData.current.data == null) {
      resData.current.data = {};
    }
    resData.current.data.spuList = { ...spuList, datas: arr.flat(Infinity) };
    if (spuList?.totalPage <= params.current.pageNo) {
      setLoadingText('人家也是有底线的');
    } else {
      setLoadingText('正在加载中');
    }
    // init search params by scrollTop
    if (hasScroll.current) {
      const searchParams = sessionStorage[window.location.pathname]
        ? JSON.parse(sessionStorage[window.location.pathname])
        : {
            scrollTop: 0,
            condition: {
              sorts: [],
            },
          };
      // @ts-ignore
      conditionRef.current.checkCondition(searchParams.condition);
      //  fix back lost type data
      if (searchParams.condition?.categorySysNoList?.length > 0) {
        const res: any = await materialsSearch({
          catId: router.query.catId,
          key: router.query.key,
          shopSysNo: shopSysNo || router.query.shopSysNo,
          agreementSysNoList,
          contractAgreementSysNoList,
        });
        categoryList = res?.data?.categoryList || [];
        hotCategoryList = res?.data?.hotCategoryList || [];
      }
      if (searchParams.conditionList) {
        setConditionList(searchParams.conditionList);
        setConditionTypeList({ categoryList, hotCategoryList });
        conditionListRef.current = searchParams.conditionList;
      } else {
        setConditionList(
          [
            //   GoodsFn(props.kdyxType ? [Number(props.kdyxType)] : [1, 2]),
            upstreams,
            brands,
            ...spuAttributeList,
          ].filter(Boolean),
        );
        setConditionTypeList({ categoryList, hotCategoryList });
        conditionListRef.current = [upstreams, brands, ...spuAttributeList].filter(Boolean);
      }
      hasScroll.current = false;
      setEndSkeleton(true);
      setTimeout(() => {
        if (listRef.current) {
          listRef.current.scrollTop = Number(searchParams.scrollTop) || 0;
        }
        sessionStorage.removeItem(window.location.pathname);
      });
    }
  };

  useEffect(() => {
    // 获取缓存差查询参数， 根据地区参数做不同处理
    const searchParams = sessionStorage[window.location.pathname]
      ? JSON.parse(sessionStorage[window.location.pathname])
      : {
          scrollTop: 0,
          condition: {
            sorts: [],
          },
        };
    if (location.areaCode) {
      if (hasScroll.current) {
        params.current.levelCode = location.areaCode;
        // 如果有缓存查询参数，直接取缓存查询参数、
        if (sessionStorage[window.location.pathname]) {
          if (searchParams.condition) {
            const param = {
              ...condition,
              ...searchParams.condition,
              levelCode: location.areaCode,
            };
            setCondition(param);
            params.current = { ...params.current, ...param };
          }
        }
        if (searchParams.datas) {
          // 如果有缓存列表数据，直接取缓存商品列表数据， 不发送http请求
          params.current.pageNo = searchParams.pageNo;
          getList(true, searchParams.datas);
        } else {
          getList();
        }
      } else {
        setCondition({ ...condition, agreementSysNoList: [], contractAgreementSysNoList: [] });
        handleChangeCondition(condition, undefined, true);
      }
    }
  }, [location.areaCode]);
  // 计算单条商品展示大小
  const calcCardSize = () => {
    // 缓存商品类型
    if (localStorage.productListType) {
      if (shopSysNo) {
        if (localStorage.productListType === LIST_TYPE.card.name) {
          setCardHeight(LIST_TYPE.noShopCardHeight);
        } else {
          setCardHeight(LIST_TYPE.list.height);
        }
      } else {
        setCardHeight(LIST_TYPE[localStorage.productListType].height);
      }
    } else {
      // 商品类别名称设置缓存
      localStorage.productListType = LIST_TYPE.card.name;
      setCardHeight(LIST_TYPE.card.height);
    }
  };
  // 设置页面缩放监听函数
  useEffect(() => {
    const sensor = new ResizeSensor(document.body, () => {
      if (toolHeight) {
        const height = document.body.offsetHeight - conditionHeight - toolHeight;
        // NavBarHeight
        setListHeight(height);
      }
    });
    return () => {
      sensor.detach();
    };
  }, []);
  // 设置工具条高度
  useEffect(() => {
    if (toolHeight) {
      const height = document.body.offsetHeight - conditionHeight - toolHeight;
      setListHeight(height);
    }
  }, [toolHeight, showCondition]);

  // 缓存商品展示卡片大小
  useLayoutEffect(() => {
    calcCardSize();
    setListType(localStorage.productListType);
  }, []);
  // 监听商品展示卡片高度变化，如果缓存路由不存在 且 滚动缓存不存在 不发送服务端请求
  useEffect(() => {
    if (!hasScroll.current && !sessionStorage[window.location.pathname]) {
      params.current.pageNo = 1;
      getList(true);
    }
  }, [cardHeight]);
  // 店铺系统编号shopSysNo未变化时，更新商品类别，
  useEffect(() => {
    if (shopSysNo && pCondition.shopInnerTab !== condition.shopInnerTab) {
      params.current.pageNo = 1;
      params.current.shopInnerTab = pCondition.shopInnerTab;
      setCondition((v) => ({
        ...v,
        shopInnerTab: pCondition.shopInnerTab,
      }));
      getList(true);
    }
  }, [pCondition]);
  // 路由查询参数标识key 与查询参数key一致时，不发送服务端请求，取缓存商品数据
  useEffect(() => {
    if (router.query.key !== condition.key) {
      params.current.pageNo = 1;
      params.current.key = router.query.key;
      setCondition((v) => ({
        ...v,
        key: router.query.key,
      }));
      getList(true);
    }
  }, [router.query.key]);

  // TODO 20131113
  // 缓存页面查询参数
  const recordParams = () => {
    sessionStorage[window.location.pathname] = JSON.stringify({
      condition,
      scrollTop: listRef.current?.scrollTop,
      conditionList: conditionListRef.current,
      datas: resData.current,
      pageNo: params.current.pageNo,
    });
  };
  // 查询参数变化处理函数
  const handleChangeCondition = (
    newCondition: { [key: string]: any },
    list?: ConditionItem[] | ((_prevState: ConditionItem[]) => ConditionItem[]),
    reset?: boolean,
  ) => {
    // 页面滚动偏移量处理
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
    // 页面重置时，重置页面查询参数
    if (reset) {
      newCondition.brandSysNoList = [];
      newCondition.attributeNameList = null;
      newCondition.attributeValueList = null;
      newCondition.catId = router.query.catId ?? null;
      newCondition.categorySysNoList = [];
      newCondition.upstreamSupplierSysNoList = [];
    }
    // 设置商品查询层级code
    setCondition({ ...newCondition, levelCode: location.areaCode });
    // 如果页面列表数据存在， 取缓存数据，不发送服务daunt请求
    if (list) {
      conditionListRef.current = list;
    }
    params.current = {
      pageNo: 1,
      pageSize: defPageSize,
      // kdyxTypeList: kdyxTypeFormat(props.kdyxType),
      ...newCondition,
      levelCode: location.areaCode,
    };
    getList(true);
  };
  // 滚动监听函数
  const onScroll = () => {
    // 页码不存在 且 当前页小于 总页码的当前页码时重新请求商品数据
    if (!loading.current && params.current.pageNo < totalPage.current) {
      loading.current = true;
      params.current.pageNo++;
      getList();
    }
  };
  // 商品类别变化时设置缓存数据
  const changeListType = () => {
    localStorage.productListType =
      localStorage.productListType === LIST_TYPE.card.name
        ? LIST_TYPE.list.name
        : LIST_TYPE.card.name;
    setListType(localStorage.productListType);
    calcCardSize();
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
  };
  return (
    <>
      <div className="box">
        {!!showCondition && (
          <MaterialsCondition
            value={condition}
            conditionList={conditionList}
            onChange={(e, list) => handleChangeCondition(e, list)}
            changeListType={changeListType}
            ref={conditionRef}
            keyword={condition.key}
            conditionTypeList={conditionTypeList}
            shopSysNo={shopSysNo}
            listType={listType as 'card' | 'list'}
          />
        )}
        {data.length > 0 ? (
          <VirtualList
            scrollBottomFn={onScroll}
            ref={listRef}
            overscanCount={50}
            height={listHeight}
            itemSize={cardHeight}
            loadingText={loadingText}
            item={(row: any[], index?: number) => (
              <RenderCard
                row={row}
                index={index}
                recordParams={recordParams}
                shopSysNo={shopSysNo}
                listType={listType as 'card' | 'list'}
                isOutSide={isOutSide}
              />
            )}
            data={listType === LIST_TYPE.list.name ? data.flat() : data}
            listType={listType as 'card' | 'list'}
          />
        ) : hasScroll.current && !endSkeleton ? (
          listType === LIST_TYPE.card.name ? (
            <CardSkeleton />
          ) : (
            <ListSkeleton />
          )
        ) : (
          <Nodata
            text={showChangeArea && showCondition ? '当前地区暂无可售商品' : '暂无数据'}
            showNav={true}
            nodata={true}
            operatingArea={
              showChangeArea && showCondition ? (
                <Button
                  text="切换区域"
                  type="primary"
                  style={{ width: 120 }}
                  onClick={() => {
                    (conditionRef.current.areaPicker as HTMLDivElement).click();
                  }}
                />
              ) : null
            }
          />
        )}
      </div>
      <style jsx>{`
        .box {
          background-color: ${listType === LIST_TYPE.list.name ? '#ffffff' : '#f7f7f7'};
        }
      `}</style>
    </>
  );
}
type IProductCard = {
  row: any;
  index?: number;
  recordParams: Function;
  shopSysNo?: string;
  listType: 'card' | 'list';
  isOutSide?: boolean;
};
// 单挑商品展示组件
const RenderCard = ({ row, recordParams, shopSysNo, listType, isOutSide }: IProductCard) => {
  return listType === LIST_TYPE.list.name ? (
    <>
      <div className="cardBox">
        <ProductListItem
          cardClick={recordParams}
          data={row}
          {...row}
          mainImage={row?.images?.[0]}
          href={`/product/detail?id=${row?.bestSkuSysNo}`}
          hideShop={shopSysNo}
          upstreamSupplierName={isOutSide ? null : row?.upstreamSupplierName}
        />
      </div>
      <style jsx>{`
          .cardBox {
            padding: 0 16px;
            padding-bottom: 20px;
            background-color: #ffffff;
          }
        `}</style>
    </>
  ) : (
    <>
      <div className="cardBox">
        {row?.map((v: any, i: any) => {
          return (
            <MaterialsCard
              key={i}
              cardClick={recordParams}
              skuDetail={v}
              {...v}
              mainImage={v.images?.[0]}
              href={`/product/detail?id=${v.bestSkuSysNo}`}
              hideShop={shopSysNo}
              noShopCardHeight={LIST_TYPE.noShopCardHeight}
              upstreamSupplierName={isOutSide ? null : row?.upstreamSupplierName}
            />
          );
        })}
      </div>
      <style jsx>{`
          .cardBox {
            padding: 0 16px;
            padding-bottom: 5px;
            background-color: #f7f7f7;
            display: flex;
            justify-content: space-between;
          }
      `}</style>
    </>
  );
};
